import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/moment.js'
import './plugins/axios.js'
import './plugins/common.js'
import 'normalize.css' // A modern alternative to CSS resets
import './styles/c.less'
import './components'
import './filter'

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV) //第三方大屏组件引入全局
    //--------------------------------------------------------------------
    // 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
// 全局注册图标
Vue.component('icon', Icon);

// 适配flex
import '@/utils/flexible.js';

// 引入全局css
import './assets/scss/style.scss';
import ElementUI from 'element-ui';
Vue.use(ElementUI);



//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
import 'echarts/map/js/china.js'

import jquery from "jquery"
Vue.prototype.$ = jquery;

import ZkTable from 'vue-table-with-tree-grid'
Vue.use(ZkTable)

//--------------------------------------------------------------------
Vue.config.productionTip = false

new Vue({
    router,
    store,
    // dataV, //这里不能引入第三方组件
    render: h => h(App),
}).$mount('#app')